import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ListViewSettingModel } from '../../components/items-list/list-view-setting.model';
import { ListViewSettingsService } from '@fi-app/utilities/fi-services/list-view-settings.service';
import { ObjectTypes } from '@fi-shared/types';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { UserService } from '@fi-app/user/user.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { isNullOrUndefined } from '@fi-shared/utils/is-null-or-undefined';

@Component({
    selector: 'fi-user-list-container',
    template: `
        @if (loading$ | async) {
          <div class="text-center">
            <fi-loading class="small"></fi-loading>
          </div>
        }
        @if (userListViewSettings$ | async; as userListViewSettings) {
          <fi-user-list
            [userListViewSettings]="userListViewSettings"
            >
          </fi-user-list>
        }
        `,
    styleUrls: ['./user-list-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-user-list-container' },
    standalone: false,
})
export class UserListContainerComponent implements OnInit {
    userListViewSettings$ = new ReplaySubject<ListViewSettingModel>(1);
    loading$ = new BehaviorSubject<boolean>(true);
    @Input() initialSearchObjects;

    constructor(
        private listViewSettingsService: ListViewSettingsService,
        private userService: UserService,
        private fiStateService: FiStateService,
    ) {}

    ngOnInit() {
        this.listViewSettingsService
            .getSetting(ObjectTypes.User)
            .then((listViewSettings) => {
                this.userListViewSettings$.next(listViewSettings);
            })
            .finally(() => this.loading$.next(false));
        this.openUserProfileDialog();
    }

    private openUserProfileDialog() {
        if (!isNullOrUndefined(this.fiStateService.params?.UserId))
            this.userService.openUserViewDialog(this.fiStateService.params?.UserId);
    }
}
